import { Moon, Sun } from "lucide-react";
import type { ComponentPropsWithoutRef } from "react";
import { Theme, useTheme } from "remix-themes";
import { Tooltip, TooltipContent, TooltipTrigger } from "ui";
import { cn } from "~/utils/utils";

const ThemeSwitcher = ({ className }: ComponentPropsWithoutRef<"button">) => {
  /*const [theme, setTheme] = useTheme();

  const toggleTheme = () => {
    setTheme((prevTheme) =>
      prevTheme === Theme.LIGHT ? Theme.DARK : Theme.LIGHT
    );
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          id="theme-toggle"
          type="button"
          onClick={toggleTheme}
          className={cn(
            "rounded-full p-2 text-slate-500 hover:bg-slate-200 focus:outline-none focus:ring-4 focus:ring-slate-200 dark:text-slate-200 dark:hover:bg-slate-600 dark:focus:ring-slate-700",
            className
          )}
        >
          {theme === Theme.DARK ? (
            <Moon className="h-5 w-5" />
          ) : (
            <Sun className="h-5 w-5" />
          )}
        </button>
      </TooltipTrigger>
      <TooltipContent side="bottom">
        Switch to {theme === Theme.LIGHT ? "dark" : "light"} mode
      </TooltipContent>
    </Tooltip>
  );*/
  return <></>;
};

export default ThemeSwitcher;
